import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Keyboard, Mousewheel } from 'swiper/modules';
import { AppSwal } from '../../Services/alertService';
import { ApiCallService } from '../../Services/ApiCallService';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';

export interface EnquiryForm {
  Name: string;
  Email: string;
  Phone: string;
  Location: string;
  CityID: number | null;
  Interest: string;
  Message: string;
  // InterestedIn?: string;
  consent: boolean;
}
export interface TreatmentItemModel {
  TreatmentItemID: number;
  TreatmentName: string;
  MainCategory: string | null;
  Description: string | null;
  Benefits: string | null;
  Price: number;
  CityID: number | null;
  Image: string | null;
  IsActive?: number | boolean;
}
export interface TreatmentCategory {
  category: string;
  image: string;   // image of the first treatment in this category
  route: string;
}
export interface Blog {
  ID: number;
  Title: string;
  Description: string;
  EventDate: string;
  Tags: string;
  BannerImage: string;
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule, HttpClientModule, DatePipe],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home implements OnInit, AfterViewInit {
  constructor(
    private api: ApiCallService,
    private http: HttpClient,
    private router: Router,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }
  blogs: Blog[] = [];
  baseImageUrl = 'https://crm-api.redmonkwellness.com/';
  apiUrl = 'https://crm-api.redmonkwellness.com/Navigation/ExecuteBlogSP';
  ngOnInit(): void {
    this.getLatestBlogs();
  }

  cities = [
    { CityID: 1, CityName: 'Mumbai' },
    { CityID: 2, CityName: 'Kolkata' },
  ];

  getLatestBlogs(): void {
    const payload = {
      Action: 'GETLATEST3',
    };

    this.http.post<any>(this.apiUrl, payload).subscribe({
      next: (res) => {
        // console.log(res);

        if (res.success) {
          this.blogs = res.data;
        }
      },
      error: (err) => {
        console.error(err);
      },
    });
  }
  formatDescription(description: string): string {
    if (!description) {
      return '';
    }

    // Replace the arrow
    const formatted = description.replace(
      /<span([^>]*)>\s*-/gi,
      '<span$1><span class="red-arrow">➜</span> ',
    );

    // Remove HTML tags to count plain text
    const plainText = formatted.replace(/<[^>]+>/g, '');

    if (plainText.length <= 120) {
      return formatted;
    }

    return plainText.substring(0, 120) + '...';
  }
  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // Swiper
    new Swiper('.custom-swiper', {
      modules: [Navigation, Pagination, Autoplay, Keyboard, Mousewheel],

      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1000,
      loop: true,

      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      navigation: {
        nextEl: '.custom-swiper-button-next',
        prevEl: '.custom-swiper-button-prev',
      },

      pagination: {
        el: '.custom-pagination',
        clickable: true,
        dynamicBullets: true,
      },

      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
    });

    // Initialize Tabs
    this.initTabs();
  }

  //-----Tabs start
  private initTabs(): void {
    const nav = document.getElementById('treatmentNav');
    const tabContainer = document.getElementById('tabContents');

    if (!nav || !tabContainer) {
      console.error('Tab container not found');
      return;
    }

    nav.onclick = (event: Event) => {
      const target = event.target as HTMLElement;

      const clickedTab = target.closest('.treatment-tab') as HTMLElement;

      if (!clickedTab) {
        return;
      }

      // Remove active class from tabs
      nav.querySelectorAll('.treatment-tab').forEach((tab) => {
        tab.classList.remove('active');
      });

      // Remove active class from contents
      tabContainer.querySelectorAll('.tab-content').forEach((content) => {
        content.classList.remove('active');
      });

      // Activate clicked tab
      clickedTab.classList.add('active');

      // Show matching content
      const tabId = clickedTab.dataset['tab'];

      if (!tabId) {
        return;
      }

      const activeContent = tabContainer.querySelector(`#${tabId}`);

      if (activeContent) {
        activeContent.classList.add('active');
      }
    };
  }

  //-----Tabs end

  showWellness = false;
  showBeauty = false;

  wellnessItems: TreatmentItemModel[] = [];
  beautyItems: TreatmentItemModel[] = [];
  treatmentCategories: TreatmentCategory[] = [];
  loadingItems = false;
  loadingTreatments = false;
  private itemsLoaded = false;
  private treatmentsLoaded = false;

  private readonly WELLNESS_CATEGORY = 'Wellness I.V. Therapy';
  private readonly BEAUTY_CATEGORY = 'Beauty I.V. Therapy';

  scrollToSection(sectionId: string): void {
    if (sectionId === 'wellness') {
      this.showWellness = true;
      this.loadItems();
    }

    if (sectionId === 'beauty') {
      this.showBeauty = true;
      this.loadItems();
      this.loadTreatments();
    }

    setTimeout(() => {
      document.getElementById(sectionId)?.scrollIntoView({
        behavior: 'smooth',
      });
    });
  }

  // ---------- Wellness / Beauty I.V. items (Calendar/GetAllTreatmentItems, split by MainCategory) ----------
  loadItems(): void {
    if (this.itemsLoaded || this.loadingItems) return;
    this.loadingItems = true;

    this.api.postData('Calendar', 'GetAllTreatmentItems', {}).subscribe({
      next: (res: any) => {
        this.loadingItems = false;
        if (!res?.Success) return;

        const items = (res.TreatmentItems || []) as TreatmentItemModel[];
        this.wellnessItems = this.pickByCategory(items, this.WELLNESS_CATEGORY);
        this.beautyItems = this.pickByCategory(items, this.BEAUTY_CATEGORY);
        this.itemsLoaded = true;
      },
      error: (err) => {
        this.loadingItems = false;
        console.error(err);
      },
    });
  }

  // Items of one MainCategory, oldest first. Items saved per city under the same name are shown once.
  private pickByCategory(items: TreatmentItemModel[], category: string): TreatmentItemModel[] {
    const seen = new Set<string>();
    return items
      .filter((i) => (i.MainCategory || '').trim().toLowerCase() === category.toLowerCase()&&
        Number(i.IsActive ?? 0) === 0)
      .sort((a, b) => a.TreatmentItemID - b.TreatmentItemID)
      .filter((i) => {
        const key = (i.TreatmentName || '').trim().toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  }

  // ---------- Treatments (Treatment/GetTreatment) ----------
  // loadTreatments(): void {
  //   if (this.treatmentsLoaded || this.loadingTreatments) return;
  //   this.loadingTreatments = true;

  //   this.api.postData('Treatment', 'GetTreatment', {}).subscribe({
  //     next: (res: any) => {
  //       this.loadingTreatments = false;
  //       if (!res?.success) return;

  //       this.treatmentCategories = this.groupByCategory(res.TreatmentHistory ?? []);
  //       this.treatmentsLoaded = true;
  //     },
  //     error: (err) => {
  //       this.loadingTreatments = false;
  //       console.error(err);
  //     },
  //   });
  // }

  // ---------- Treatments (Treatment/GetTreatment) ----------
  loadTreatments(): void {
    if (this.treatmentsLoaded || this.loadingTreatments) return;
    this.loadingTreatments = true;

    this.api.postData('Treatment', 'GetTreatment', {}).subscribe({
      next: (res: any) => {
        this.loadingTreatments = false;
        if (!res?.success) return;

        const activeList = (res.TreatmentHistory ?? []).filter(
          (t: any) => Number(t.IsActive) === 0 &&
              (t.TreatmentType || '').trim().toLowerCase() === 'procedure'          
        );
        //console.log("all data:", res.TreatmentHistory);
        //console.log(activeList);
        this.treatmentCategories = this.groupByCategory(activeList);
        this.treatmentsLoaded = true;
      },
      error: (err) => {
        this.loadingTreatments = false;
        console.error(err);
      },
    });
  }

  // Category -> its own page. Key = category name in small letters, exactly as in the dashboard.
  // Categories not listed go to /Timelessmonk.
  private readonly categoryRoutes: Record<string, string> = {

    'hair treatments': '/hairtreatments',
    'hair treatment': '/hairtreatments',
    'skin boosters': '/skinboosters',
    //'skin boosters treatments': '/skinboosters',
    'signature facials & glow treatments': '/signaturefacialsglowtreatments',
    'advanced skin treatments & peels': '/advancedskintreatmentspeels',
    'skin tightening & rejuvenation': '/skinTighteningRejuvenation',
    'laser & removal treatments': '/laserRemovalTreatment',
    // add these two when you create their pages (use the path from routes.ts):
    'skin concern treatments': '/skin-concern-treatments',
    'bridal & luxury programs': '/bridal-luxury-programs',
    'consultation & analysis': '/consultation-analysis',
    
  };

  // One entry per Category, using the image of its first (lowest ID) treatment.
  private groupByCategory(list: any[]): TreatmentCategory[] {
    const map = new Map<string, TreatmentCategory>();
    [...list]
      .sort((a, b) => a.ID - b.ID)
      .forEach((x) => {
        const category = (x.Category ?? '').trim();
        if (!category || map.has(category)) return;
        map.set(category, {
          category,
          image: x.Image ?? '',
          route: this.categoryRoutes[category.toLowerCase()] ?? '/Timelessmonk',
        });
      });
    return [...map.values()];
  }

  // Category -> existing detail page. Categories not listed go to /Timelessmonk.
  // The category name is also sent as ?category=... so the target page can load all its treatments.
  // private readonly categoryRoutes: Record<string, string> = {
  //   'hair treatments': '/Hairtreatments',
  //   'hair treatment': '/Hairtreatments',
  //   'skin boosters': '/Skinboosters',
  //   'signature facials & glow treatments': '/Signaturefacialsglowtreatments',
  //   'advanced skin treatments & peels': '/Advancedskintreatmentspeels',
  // };

  // // One entry per Category, using the image of its first (lowest ID) treatment.
  // private groupByCategory(list: any[]): TreatmentCategory[] {
  //   const map = new Map<string, TreatmentCategory>();
  //   [...list]
  //     .sort((a, b) => a.ID - b.ID)
  //     .forEach((x) => {
  //       const category = (x.Category ?? '').trim();
  //       if (!category || map.has(category)) return;
  //       map.set(category, {
  //         category,
  //         image: x.Image ?? '',
  //         route: this.categoryRoutes[category.toLowerCase()] ?? '/Timelessmonk',
  //       });
  //     });
  //   return [...map.values()];
  // }

  // Treatment images are saved as "/Content/Treatments/xxx.jpg" on the site that uploads them.
  // If they 404 on the API host, point this to the dashboard site's URL instead.
  treatmentImageBase = this.baseImageUrl;

  // ---------- Image helpers ----------
  imgUrl(path: string | null | undefined, base: string = this.baseImageUrl): string {
    if (!path) return '';
    if (/^https?:\/\//i.test(path) || path.startsWith('data:')) return path;
    return base + path.replace(/^\/+/, '');
  }

  // Keys of images that failed to load; the template then shows the alt text instead.
  failedImages = new Set<string>();

  onImgError(key: string): void {
    this.failedImages.add(key);
  }

  enquiryForm: EnquiryForm = {
    Name: '',
    Email: '',
    Phone: '',
    Location: '',
    CityID: null,
    Interest: '',
    Message: '',
    consent: false,
    // InterestedIn: ''
  };

  validateEnquiryForm(): boolean {
    // Name validation
    if (!this.enquiryForm.Name || this.enquiryForm.Name.trim().length < 2) {
      AppSwal.fire('Empty Field', 'Name is required and must be at least 2 characters', 'info');
      console.error('Name is required and must be at least 2 characters');
      return false;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!this.enquiryForm.Email || !emailRegex.test(this.enquiryForm.Email)) {
      AppSwal.fire('Empty Field', 'A valid email is required', 'info');
      console.error('Valid email is required');
      return false;
    }

    // Phone validation
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!this.enquiryForm.Phone || !phoneRegex.test(this.enquiryForm.Phone)) {
      AppSwal.fire('Phone', 'A valid 10-digit phone number is required', 'info');
      console.error('Valid 10-digit phone number is required');
      return false;
    }

    // Location validation
    // if (!this.enquiryForm.Location || this.enquiryForm.Location.trim().length === 0) {
    //   AppSwal.fire('Empty Field', 'Location is required', 'info');
    //   console.error('Location is required');
    //   return false;
    // }

    if (!this.enquiryForm.CityID) {
      AppSwal.fire('Empty Field', 'City is required', 'info');
      console.error('City is required');
      return false;
    }

    // Interest validation
    if (!this.enquiryForm.Interest || this.enquiryForm.Interest.trim().length === 0) {
      AppSwal.fire('Empty Field', 'Interest selection is required', 'info');
      console.error('Interest selection is required');
      return false;
    }

    // Message validation
    // if (!this.enquiryForm.Message || this.enquiryForm.Message.trim().length < 10) {
    //   AppSwal.fire('Empty Field', 'Message must be at least 10 characters', 'info');
    //   console.error('Message must be at least 10 characters');
    //   return false;
    // }

    // consent validation
    if (!this.enquiryForm.consent) {
      AppSwal.fire('Empty Field', 'consent selection is required', 'info');
      console.error('consent selection is required');
      return false;
    }

    return true;
  }

  submitEnquiryForm(): void {
    this.cdr.detectChanges();
    // STEP 1: Client-side validation
    if (!this.validateEnquiryForm()) {
      return;
    }

    const selectedCity = this.cities.find((c) => c.CityID === this.enquiryForm.CityID);
    this.enquiryForm.Location = selectedCity ? selectedCity.CityName : '';

    // STEP 2: Prepare payloads (single source of truth)
    const otpPayload = {
      clientEmail: this.enquiryForm.Email,
    };

    // const mailPayload = {
    //   name: this.enquiryForm.Name,
    //   clientEmail: this.enquiryForm.Email,
    //   phone: this.enquiryForm.Phone,
    //   location: this.enquiryForm.Location,
    //   interestedin: this.enquiryForm.Interest,
    //   message: this.enquiryForm.Message,
    //   title: 'RedMonk Wellness',
    // };
    const mailPayload = {
      Name: this.enquiryForm.Name,
      Email: this.enquiryForm.Email,
      MobileNo: this.enquiryForm.Phone,
      City: this.enquiryForm.Location,
      Interest: this.enquiryForm.Interest,
      Message: this.enquiryForm.Message,
      //title: 'RedMonk Wellness',
    };

    // Prepare lead registration payload
    // const leadPayload = {
    //   LeadName: this.enquiryForm.Name,
    //   LeadEmail: this.enquiryForm.Email,
    //   Query: this.enquiryForm.Message,
    //   Gender: '',
    //   Address: this.enquiryForm.Location,
    //   City: this.enquiryForm.Location,
    //   ContactInfo: this.enquiryForm.Phone,
    //   Source: 'Website',
    //   FormType: this.enquiryForm.Interest,
    //   CreatedBy: 1,
    //   Age: 0,
    //   CreatedByRole: '',
    //   AssignedToID: 0,
    //   AssignedToRole: '',
    //   FormConsent: this.enquiryForm.consent,
    // };

    console.log(this.enquiryForm);
    console.log('it is working till now before send otp');

    // STEP 3: Show loader before sending OTP
    AppSwal.fire({
      title: 'Please wait...',
      text: 'Sending Verification Code to your email...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => AppSwal.showLoading(),
    });

    // STEP 4: Send OTP
    // this.api.postData('User', 'SendEmailOtp', otpPayload).subscribe({
    this.api.postData('User', 'SendEmailOtp', otpPayload).subscribe({
      next: (res: any) => {
        AppSwal.close(); // Close loader after API response

        if (!res?.success) {
          AppSwal.fire('Failed', 'Unable to send Verification Code. Please try again.', 'error');
          return;
        }

        // STEP 5: OTP input popup
        AppSwal.fire({
          title: 'Verification Code',
          text: 'Please enter the Verification Code sent to your email',
          input: 'text',
          inputPlaceholder: 'Enter 6-digit Verification Code',
          inputAttributes: {
            maxlength: '6',
            inputmode: 'numeric',
            autocomplete: 'one-time-code',
            autocapitalize: 'off',
            autocorrect: 'off',
          },
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-secondary',
          },
          buttonsStyling: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: true,
          confirmButtonText: 'Verify Code',
          cancelButtonText: 'Cancel',
          focusConfirm: false,
          preConfirm: (otp) => {
            if (!otp) {
              AppSwal.showValidationMessage('Verification Code is required');
              return false;
            }
            if (!/^[0-9]{6}$/.test(otp)) {
              AppSwal.showValidationMessage('Verification Code must be a 6-digit number');
              return false;
            }
            return otp;
          },
        }).then((result) => {
          if (!result.isConfirmed) return;

          const verifyPayload = {
            otp: result.value,
            email: this.enquiryForm.Email,
          };

          // STEP 6: Verify OTP (loader)
          AppSwal.fire({
            title: 'Verifying',
            text: 'Please wait...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => AppSwal.showLoading(),
          });

          this.api.postData('User', 'VerifyOtp', verifyPayload).subscribe({
            next: (verifyRes: any) => {
              AppSwal.close();

              if (!verifyRes?.success) {
                AppSwal.fire(
                  'Invalid Verification Code',
                  'The Verification Code you entered is incorrect.',
                  'error',
                );
                return;
              }

              // STEP 7: OTP verified successfully - Insert lead and send email simultaneously
              // Show single processing message
              AppSwal.fire({
                title: 'Processing',
                text: 'Submitting your enquiry...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => AppSwal.showLoading(),
              });

              // Call both APIs simultaneously
              //             const leadRegistration = this.api
              //               .postData('UserRoles', 'RegisterLeads', leadPayload)
              //               .toPromise();
              //             const sendEmail = this.api
              //               .postData('Notification', 'SendMail', mailPayload)
              //               .toPromise();

              //             Promise.all([leadRegistration, sendEmail])
              //               .then(([leadRes, mailRes]: [any, any]) => {
              //                 AppSwal.close();
              //                 console.log('Lead Registration Response:', leadRes);
              //                 console.log('Email Response:', mailRes);

              //                 // Check if at least one operation succeeded
              //                 if (
              //                   leadRes?.success === true ||
              //                   leadRes?.status === true ||
              //                   mailRes?.success === true
              //                 ) {
              //                   AppSwal.fire(
              //                     'Success',
              //                     'Your enquiry has been submitted successfully!',
              //                     'success',
              //                   ).then(() => {
              //                     this.router.navigateByUrl('/Thankyou');
              //                   });
              //                 } else {
              //                   AppSwal.fire(
              //                     'Failed',
              //                     'Unable to submit your enquiry. Please try again.',
              //                     'error',
              //                   );
              //                 }
              //               })
              //               .catch((error) => {
              //                 AppSwal.close();
              //                 console.error('Error in parallel operations:', error);
              //                 AppSwal.fire('Error', 'Something went wrong. Please try again.', 'error');
              //               });
              //           },
              //           error: () => {
              //             AppSwal.close();
              //             AppSwal.fire(
              //               'Error',
              //               'Verification Code verification failed. Please try again.',
              //               'error',
              //             );
              //           },
              //         });
              //       });
              //     },
              //     error: () => {
              //       AppSwal.close();
              //       AppSwal.fire(
              //         'Error',
              //         'Unable to initiate Verification Code verification. Please try again.',
              //         'error',
              //       );
              //     },
              //   });
              // }
              const sendCredentials = this.api
                .postData('User', 'InsertEnquiryDetails', mailPayload)
                .subscribe({
                  next: (credRes: any) => {
                    AppSwal.close();

                    if (credRes?.success) {
                      AppSwal.fire(
                        'Success',
                        'Your enquiry has been submitted successfully.',
                        'success'
                      ).then(() => {
                        this.router.navigateByUrl('/Thankyou');
                      });
                    } else {
                      AppSwal.fire(
                        'Failed',
                        credRes?.message || 'Unable to submit enquiry.',
                        'error'
                      );
                    }
                  },
                  error: () => {
                    AppSwal.close();
                    AppSwal.fire(
                      'Error',
                      'Something went wrong while submitting enquiry.',
                      'error'
                    );
                  }
                });
            },
            error: () => {
              AppSwal.close();
              AppSwal.fire(
                'Error',
                'Verification Code verification failed. Please try again.',
                'error',
              );
            },
          });
        });
      },
      error: () => {
        AppSwal.close();
        AppSwal.fire(
          'Error',
          'Unable to initiate Verification Code verification. Please try again.',
          'error',
        );
      },
    });
  }

}